import React, { Component } from 'react';
import './style.css';
import { ModalHeader, ModalBody, ModalFooter, Button, Card } from 'reactstrap';
import MyAutosuggest from '../../../../components/ReusableComponents/AutoSuggest/index'
import { handleScoreChange, deleteRiskFactor, updatedScore, overriddingSearchUpdate, checkDuplicatedValue } from './helper';
import FinancialList from './FinancialList/index';
import NonFinancialData from './nonFinancialList/index';
import { OVERRIDDING, RECALCULATE, CLOSE, SAVE } from '../../constants';
class CaseScorecardEdit extends Component {
    constructor() {
        super();
        this.state = {
            value: '',
            financialList: [],
            nonFinancialList: [],
            overriddingSearch: [],
            overriddingList: null,
            reCalculatedScore: 0,
            caseScorecardUpdatedData: {
                financialData: [],
                nonFinancialData: []
            },
            errorMessage: null,
            showModal: false,
            body: null
        }
    }
    componentDidMount() {
        this.overriddingSearchResults(this.state.caseScorecardUpdatedData.overridingRiskFactors);
    }
    handleFinancialCallback = (type, event, id) => {
        const tempScoreData = handleScoreChange(event.target.value, this.props.caseScorecardUpdatedData, id, type);
        const tempCaseData = updatedScore(this.props.caseScorecardUpdatedData, tempScoreData, type)
        this.props.updateModalData(tempCaseData)
    }
    updateScorecardData = () => {
        this.setState({
            overriddingSearch: this.props.caseScorecardUpdatedData.overridingRiskFactors,
            errorMessage: <span className="">{this.props.caseScorecardError}</span>
        }, () => {
            this.overriddingSearchResults()
        })

    }
    static getDerivedStateFromProps(nextProps, prevState) {
        return {
            caseScorecardUpdatedData: nextProps.caseScorecardUpdatedData,
            overriddingSearch: nextProps.caseScorecardUpdatedData.overridingRiskFactors,
            errorMessage: <span className="text-danger">{nextProps.caseScorecardError}</span>,
            closeDisable: nextProps.closeDisable
        }
    }
    searchCallback = (searchResult, searchType) => {
        if (searchType === OVERRIDDING) {
            // const searchResultUpdate = caseScorecardEditOverriddingRisk(searchResult);
            const checkDuplicateValue = checkDuplicatedValue(this.state.caseScorecardUpdatedData.overridingRiskFactors, searchResult)
            this.overriddingSearchResults(checkDuplicateValue);
        }
    }
    handleOverriddingDeleteRisk = (event, id, overriddingData) => {
        const tempOverriddingrisk = deleteRiskFactor(overriddingData, id);
        this.overriddingSearchResults(tempOverriddingrisk);
    }
    overriddingSearchResults = (data) => {
        const tempCaseScorecardData = overriddingSearchUpdate(this.state.caseScorecardUpdatedData, data);
        this.setState({
            overriddingList: data.map(p => {
                return (
                    <tr key={p.id} >
                        <td key={p.id + 'td'}>
                            {p.name}
                        </td>
                        <td key={p.id + 'td1'}>{p.score}</td>
                        <td className="text-right" key={p.id + 'td2'}>
                            <button key={p.id + 'button'} type="button" id={p.id} className="btn btn-sm btn-link border-0 text-danger pr-0" title="Delete Financial Factor" onClick={(event) => this.handleOverriddingDeleteRisk(event, p.id, data)}>
                                Remove
                            </button>
                        </td>
                    </tr>
                );
            }),
            caseScorecardUpdatedData: tempCaseScorecardData
        })
    }
    handleClose = () => {
        this.props.modalCallback(false);
    }
    handleActionButtons = (event) => {
        window.scrollTo(0, 0);
        switch (event.target.name) {
            case RECALCULATE:
                return this.props.modalCallback(this.state.caseScorecardUpdatedData, RECALCULATE)
            case SAVE:
                return this.props.modalCallback(this.state.caseScorecardUpdatedData, SAVE)
            case CLOSE:
                return this.props.modalCallback(this.state.caseScorecardUpdatedData, CLOSE)
            default:
                return null;
        }
    }
    render() {
        const { value } = this.state
        const inputProps = {
            placeholder: "Start typing Risk Factor Name...",
            onChange: this.onChange,
            disabled: false,
            className: "form-control",
            value: value
        }
        let automatedOverridding = [];
        let overriddingName = [];
        let automatedOverridingRiskFactors = this.props.caseScorecardUpdatedData.automatedOverridingRiskFactors
        if(automatedOverridingRiskFactors !== null){
            automatedOverridingRiskFactors.forEach((factor) => {
                if(!overriddingName.includes(factor.name)){
                    //if(factor.isAutomated){
                        overriddingName.push(factor.name)
                        automatedOverridding.push(<tr><td>{factor.name}</td><td>{factor.score}</td></tr>)
                    //}
                }
              })
        }
        return (
            <Card>
                <ModalHeader>Edit Scorecard</ModalHeader>
                <ModalBody>
                    <table className="table table-bordered border-bottom-0 mb-4">
                        <thead>
                            <tr>
                                <th width="60%">Scorecard Name</th>
                                <th width="20%">Current Score</th>
                                <th width="20%">Current Risk Grade</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td> {this.state.caseScorecardUpdatedData.name} </td>
                                <td> {Math.round(this.state.caseScorecardUpdatedData.score * 10) / 10} </td>
                                <td> {this.state.caseScorecardUpdatedData.riskGrade} </td>
                            </tr>
                        </tbody>
                    </table>
                    <div className="mb-4">
                        <h6><strong>Financial Factors</strong></h6>
                        <table className="table table-bordered border-bottom-0 mb-0">
                            <thead className="header-blue">
                                <tr>
                                    <th width="40%">Factor</th>
                                    <th width="20%">Current Score</th>
                                    <th width="30%">Score</th>
                                    <th width="10%">Weight</th>
                                </tr>
                            </thead>
                            <tbody>
                                <FinancialList data={this.props.caseScorecardUpdatedData.financialData} financialDataCallback={this.handleFinancialCallback} />
                            </tbody>
                        </table>
                    </div>
                    <div className="mb-4">
                        <h6><strong>Non Financial Factors</strong></h6>
                        <table className="table table-bordered border-bottom-0 mb-0">
                            <thead className="header-blue">
                                <tr>
                                    <th width="40%">Factor</th>
                                    <th width="20%">Current Score</th>
                                    <th width="30%">Score</th>
                                    <th width="10%">Weight</th>
                                </tr>
                            </thead>
                            <tbody>
                                <NonFinancialData data={this.props.caseScorecardUpdatedData.nonFinancialData} financialDataCallback={this.handleFinancialCallback} />
                            </tbody>
                        </table>
                    </div>
                    <div className="mb-4">
                        <h6><strong>Automated Overridding Factors</strong></h6>
                        <table className="table table-bordered border-bottom-0 mb-0">
                            <thead className="header-blue">
                                <tr>
                                    <th width="70%">Factor</th>
                                    <th width="30%">Score</th>
                                </tr>
                            </thead>
                            <tbody>
                                {automatedOverridding}
                            </tbody>
                        </table>
                    </div>
                    <div className="mb-4">
                        <h6><strong>Manual Overridding Factors</strong></h6>
                        <table className="table table-bordered border-bottom-0 mb-0">
                            <thead className="header-blue">
                                <tr>
                                    <th width="60%">Factor</th>
                                    <th width="30%">Score</th>
                                    <th width="10%">Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.state.overriddingList}
                            </tbody>
                            
                        </table>
                        <MyAutosuggest id="overridding"
                            placeholder="Search &amp; Add Overridding Risk Factors"
                            onChange={this.handleNonFinancialChange}
                            financialData={this.state.overriddingSearch}
                            searchCallback={this.searchCallback}
                            inputProps={inputProps} />
                    </div>

                    {/* </Card> */}
                </ModalBody>
                {this.state.errorMessage}
                <ModalFooter>
                    <Button color="info" name="Recalculate" onClick={this.handleActionButtons}>Recalculate Score</Button>
                    <Button color="info" name="Save" onClick={this.handleActionButtons}>Save</Button>
                    <Button color="info" name="Close" onClick={this.handleClose}>Close</Button>
                </ModalFooter>
            </Card >
        )
    }
}

export default CaseScorecardEdit;